"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _effect = _interopRequireDefault(require("./effect.js"));
var _Detail = _interopRequireDefault(require("./dialogs/Detail.vue"));
var _ProjectEdit = _interopRequireDefault(require("./dialogs/ProjectEdit.vue"));
var _ProjectCardEdit = _interopRequireDefault(require("./dialogs/ProjectCardEdit.vue"));
var _DataMigrationDialog = _interopRequireDefault(require("./dialogs/DataMigrationDialog.vue"));
var _AuditConfigDialog = _interopRequireDefault(require("./dialogs/AuditConfigDialog.vue"));
var _IntegralAuditDialog = _interopRequireDefault(require("./dialogs/IntegralAuditDialog.vue"));
var _AddGrant = _interopRequireDefault(require("@/views/business/clientManage/customerPointsManagement/dialogs/AddGrant.vue"));
var _api = require("./api");
var _request = _interopRequireDefault(require("@/utils/request"));
var _amount = require("@/utils/amount");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'record',
  components: {
    DetailVue: _Detail.default,
    ProjectEditVue: _ProjectEdit.default,
    ProjectCardEditVue: _ProjectCardEdit.default,
    DataMigrationDialog: _DataMigrationDialog.default,
    AuditConfigDialog: _AuditConfigDialog.default,
    IntegralAuditDialog: _IntegralAuditDialog.default,
    AddGrantVue: _AddGrant.default
  },
  mixins: [_effect.default],
  data: function data() {
    return {
      resubmitLoadingId: null,
      deleteLoadingId: null
    };
  },
  created: function created() {
    this.getCustomers(), this.getCompanyList();
  },
  methods: {
    // 获取状态标签类型
    getStatusTagType: function getStatusTagType(status) {
      var typeMap = {
        'PENDING': 'info',
        'PROCESSING': 'warning',
        'COMPLETED': 'success',
        'FAILED': 'danger'
      };
      return typeMap[status] || 'info';
    },
    // 获取进度条状态
    getProgressStatus: function getProgressStatus(status) {
      if (status === 'COMPLETED') return 'success';
      if (status === 'FAILED') return 'exception';
      return '';
    },
    onRefresh: function onRefresh() {
      console.log('收到刷新请求，刷新列表数据');
      this.getList();
    },
    editProjectInfo: function editProjectInfo(row) {
      // 打开项目信息编辑对话框
      this.$refs.ProjectEditVueRef.open(row);
    },
    editProjectCardInfo: function editProjectCardInfo(row) {
      this.$refs.ProjectCardEditVueRef.open(row);
    },
    revoke: function () {
      var _revoke = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id, jobId) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return this.$confirm('确定要撤回该积分发放记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                customClass: 'revoke-confirm-dialog',
                center: true
              });
            case 1:
              _context.n = 2;
              return (0, _request.default)({
                url: '/admin/customer/integral-log/revoke',
                // 移除/api前缀
                method: 'POST',
                params: {
                  jobId: jobId,
                  id: id
                }
              });
            case 2:
              this.$message.success('撤回成功');
              this.getList();
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              if (_t !== 'cancel') {
                this.$message.error('撤回失败: ' + _t.message);
              }
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[0, 3]]);
      }));
      function revoke(_x, _x2) {
        return _revoke.apply(this, arguments);
      }
      return revoke;
    }(),
    formatYuanColumn: function formatYuanColumn(row, column, cellValue) {
      return (0, _amount.formatToYuan)(cellValue);
    },
    formatToYuan: _amount.formatToYuan,
    // 根据 companyId 格式化发放公司名称
    formatCompanyName: function formatCompanyName(row, column, cellValue) {
      // 如果有 companyId，尝试从 companyList 中查找对应的发放公司名称
      if (row.companyId && this.companyList && this.companyList.length > 0) {
        var company = this.companyList.find(function (item) {
          return item.id === row.companyId;
        });
        if (company && company.name) {
          return company.name;
        }
      }
      // 如果找不到，则使用 innerCompanyName 作为兜底
      return row.innerCompanyName || '-';
    },
    openDataMigration: function openDataMigration() {
      this.$refs.DataMigrationDialogRef.open();
    },
    openAuditConfig: function openAuditConfig() {
      this.$refs.AuditConfigDialogRef.open();
    },
    openIntegralAudit: function openIntegralAudit(row) {
      this.$refs.IntegralAuditDialogRef.open(row);
    },
    resubmit: function () {
      var _resubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var response, detailData, integralId, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.resubmitLoadingId !== null)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.resubmitLoadingId = row.id;
              _context2.p = 2;
              _context2.n = 3;
              return (0, _api.infoApi)({
                id: row.id,
                page: 1,
                limit: 15
              });
            case 3:
              response = _context2.v;
              detailData = response && response.data ? response.data : response;
              if (detailData) {
                _context2.n = 4;
                break;
              }
              this.$message.error('未获取到发放批次详情，无法重新提交');
              return _context2.a(2);
            case 4:
              integralId = detailData.customerIntegralId;
              this.$refs.AddGrantVueRef.open({
                id: integralId,
                integralId: integralId,
                resubmitBatchId: row.id,
                customerId: detailData.customerId || row.customerId,
                customerName: detailData.customerName || row.customerName
              }, detailData);
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              console.error('打开重新提交弹窗失败:', _t2);
            case 6:
              _context2.p = 6;
              this.resubmitLoadingId = null;
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 5, 6, 7]]);
      }));
      function resubmit(_x3) {
        return _resubmit.apply(this, arguments);
      }
      return resubmit;
    }(),
    deleteIntegralLogBatch: function () {
      var _deleteIntegralLogBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(this.deleteLoadingId !== null)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              _context3.p = 1;
              _context3.n = 2;
              return this.$confirm("\u662F\u5426\u786E\u8BA4\u5220\u9664\u5F53\u524D\u53D1\u653E\u8BB0\u5F55?", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 2:
              this.deleteLoadingId = row.id;
              _context3.n = 3;
              return (0, _api.deleteIntegralLogBatchApi)(row.id);
            case 3:
              this.$message.success('删除成功');
              this.getList();
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              if (_t3 !== 'cancel' && _t3 !== 'close') {
                console.error('删除发放批次失败:', _t3);
              }
            case 5:
              _context3.p = 5;
              this.deleteLoadingId = null;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 4, 5, 6]]);
      }));
      function deleteIntegralLogBatch(_x4) {
        return _deleteIntegralLogBatch.apply(this, arguments);
      }
      return deleteIntegralLogBatch;
    }(),
    // 下载发放文件
    downloadFile: function downloadFile(fileUrl) {
      if (!fileUrl) {
        this.$message.warning('文件地址不存在');
        return;
      }
      window.open(fileUrl, '_blank');
    }
  }
};